module.exports = __webpack_public_path__ + "static/earn-b2fb5c2a3b1a0438da3f71f187aedee5.jpg";